import {
    LIST_RESULT_TYPES,
    LIST_RESULT_TYPES_SUCCESS,
    LIST_RESULT_TYPES_ERROR,
    ADD_RESULT_TYPES,
    SAVE_RESULT_TYPES,
    SAVE_RESULT_TYPES_SUCCESS,
    SAVE_RESULT_TYPES_ERROR,
    EDIT_RESULT_TYPES,
    UPDATE_RESULT_TYPES,
    UPDATE_RESULT_TYPES_SUCCESS,
    UPDATE_RESULT_TYPES_ERROR,
    DELETE_RESULT_TYPES,
    DELETE_RESULT_TYPES_SUCCESS,
    DELETE_RESULT_TYPES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    resultTypes: null,
    error: null,
    loading: false,
    resultTypeSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_RESULT_TYPES:
            return {
                ...state,
                loading: true
            }
        case LIST_RESULT_TYPES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_RESULT_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                resultTypes: action.payload
            }
        case SAVE_RESULT_TYPES:
        case DELETE_RESULT_TYPES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_RESULT_TYPES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_RESULT_TYPES_ERROR:
        case UPDATE_RESULT_TYPES_ERROR:
        case DELETE_RESULT_TYPES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_RESULT_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                resultTypes: [...state.resultTypes, action.payload]
            }
        case ADD_RESULT_TYPES:
            return {
                ...state,
                resultTypeSelected: null,
                isEdit: false
            }
        case EDIT_RESULT_TYPES:
            return {
                ...state,
                resultTypeSelected: action.payload,
                isEdit: true
            }
        case UPDATE_RESULT_TYPES_SUCCESS:
        case DELETE_RESULT_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                resultTypes: state.resultTypes.map(resultType => 
                    resultType.id === action.payload.id ? resultType = action.payload : resultType
                ),
                resultTypeSelected: null
            }
        // case DELETE_RESULT_TYPES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         resultTypes: state.resultTypes.filter( resultType => resultType.id !== action.payload)
        //     }
        default:
            return state;
    }
}